<template>
    <div class="back_to_index" @click="goToIndex">
        <iconList />
    </div>
</template>

<script>
export default {
    name: 'TopbarGoEvalsList',
    components: {},
    methods:{
        goToIndex(){
            this.$router.push('/evaluations')
        }
    }
}
</script>

<style lang="scss">

.back_to_index{
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        padding-top: 4px;
        width: 25px;
        fill: $grey-light;
    }
}

</style>